import { render, staticRenderFns } from "./emptyTools.vue?vue&type=template&id=fda520b0&scoped=true"
import script from "./emptyTools.vue?vue&type=script&lang=js"
export * from "./emptyTools.vue?vue&type=script&lang=js"
import style0 from "./emptyTools.vue?vue&type=style&index=0&id=fda520b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.24_css-loader@6.11.0_webpack@5.103.0__lodash@4_02e380aa463220c29513590f381609d6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda520b0",
  null
  
)

export default component.exports